//import $ from 'jquery';
//Todo: should be a json

import { BodyPartNames } from "./BodyPartNames";
import { BPID } from "../enums/BodyPartIdEnum";
import utils from "@/utils/utils";
//import logger from "@/utils/logger";

const bodyPartRepository = {

    //grade one
    'grade-one-body': require('@/assets/image/buddy/gradeOneBuddy/body.svg'),
    'grade-one-arm': require('@/assets/image/buddy/gradeOneBuddy/arm.svg'),
    //'grade-one-eyebrow': require('@/assets/image/buddy/gradeOneBuddy/eyebrow.svg'),
    'grade-one-head': require('@/assets/image/buddy/gradeOneBuddy/head.svg'),
    'grade-one-leg': require('@/assets/image/buddy/gradeOneBuddy/leg.svg'),
    'grade-one-snout': require('@/assets/image/buddy/gradeOneBuddy/snout.svg'),
    'grade-one-head_fuzz': require('@/assets/image/buddy/gradeOneBuddy/hairs.svg'),
    'grade-one-head_wrinkles': require('@/assets/image/buddy/gradeOneBuddy/head-wrinkles.svg'),
    'grade-one-body_wrinkles': require('@/assets/image/buddy/gradeOneBuddy/body-wrinkles.svg'),
    'grade-one-eyes-01': require('@/assets/image/buddy/gradeOneBuddy/eyes-01.svg'),
    'grade-one-eyes-02': require('@/assets/image/buddy/gradeOneBuddy/eyes-02.svg'),
    'grade-one-eyes-03': require('@/assets/image/buddy/gradeOneBuddy/eyes-03.svg'),
    'grade-one-eyes-04': require('@/assets/image/buddy/gradeOneBuddy/eyes-04.svg'),
    'grade-one-eyes-05': require('@/assets/image/buddy/gradeOneBuddy/eyes-05.svg'),
    'grade-one-eyes-06': require('@/assets/image/buddy/gradeOneBuddy/eyes-06.svg'),
    'grade-one-mouth-01': require('@/assets/image/buddy/gradeOneBuddy/mouth-01.svg'),
    'grade-one-mouth-02': require('@/assets/image/buddy/gradeOneBuddy/mouth-02.svg'),
    'grade-one-mouth-03': require('@/assets/image/buddy/gradeOneBuddy/mouth-03.svg'),
    'grade-one-mouth-04': require('@/assets/image/buddy/gradeOneBuddy/mouth-04.svg'),
    'grade-one-mouth-05': require('@/assets/image/buddy/gradeOneBuddy/mouth-05.svg'),
    'grade-one-mouth-06': require('@/assets/image/buddy/gradeOneBuddy/mouth-06.svg'),
    'grade-one-nose-01': require('@/assets/image/buddy/gradeOneBuddy/nose-01.svg'),
    'grade-one-nose-02': require('@/assets/image/buddy/gradeOneBuddy/nose-02.svg'),
    'grade-one-nose-03': require('@/assets/image/buddy/gradeOneBuddy/nose-03.svg'),
    'grade-one-nose-04': require('@/assets/image/buddy/gradeOneBuddy/nose-04.svg'),
    'grade-one-nose-05': require('@/assets/image/buddy/gradeOneBuddy/nose-05.svg'),
    'grade-one-nose-06': require('@/assets/image/buddy/gradeOneBuddy/nose-06.svg'),
    'grade-one-ears-01': require('@/assets/image/buddy/gradeOneBuddy/ears-01.svg'),
    'grade-one-ears-02': require('@/assets/image/buddy/gradeOneBuddy/ears-02.svg'),
    'grade-one-ears-03': require('@/assets/image/buddy/gradeOneBuddy/ears-03.svg'),
    'grade-one-ears-04': require('@/assets/image/buddy/gradeOneBuddy/ears-04.svg'),
    'grade-one-ears-05': require('@/assets/image/buddy/gradeOneBuddy/ears-05.svg'),
    'grade-one-ears-06': require('@/assets/image/buddy/gradeOneBuddy/ears-06.svg'),
    'grade-one-antenna-01': require('@/assets/image/buddy/gradeOneBuddy/antenna-01.svg'),
    'grade-one-antenna-02': require('@/assets/image/buddy/gradeOneBuddy/antenna-02.svg'),
    'grade-one-antenna-03': require('@/assets/image/buddy/gradeOneBuddy/antenna-03.svg'),
    'grade-one-antenna-04': require('@/assets/image/buddy/gradeOneBuddy/antenna-04.svg'),
    'grade-one-antenna-05': require('@/assets/image/buddy/gradeOneBuddy/antenna-05.svg'),
    'grade-one-antenna-06': require('@/assets/image/buddy/gradeOneBuddy/antenna-06.svg'),
    //grade one buddy doesn't have whiskers
    /*
    'grade-one-whiskers-01': require('@/assets/image/buddy/gradeOneBuddy/whiskers-01.svg'),
    'grade-one-whiskers-02': require('@/assets/image/buddy/gradeOneBuddy/whiskers-02.svg'),
    'grade-one-whiskers-03': require('@/assets/image/buddy/gradeOneBuddy/whiskers-03.svg'),
    'grade-one-whiskers-04': require('@/assets/image/buddy/gradeOneBuddy/whiskers-04.svg'),
    'grade-one-whiskers-05': require('@/assets/image/buddy/gradeOneBuddy/whiskers-05.svg'),
    'grade-one-whiskers-06': require('@/assets/image/buddy/gradeOneBuddy/whiskers-06.svg'),
     */

    //grade two (original)
    'body': require('@/assets/image/buddy/gradeTwoBuddy/buddy_body.svg'),
    'arm': require('@/assets/image/buddy/gradeTwoBuddy/buddy_arm.svg'),
    'eyebrow': require('@/assets/image/buddy/gradeTwoBuddy/buddy_eyebrow.svg'),
    'head': require('@/assets/image/buddy/gradeTwoBuddy/buddy_head.svg'),
    'leg': require('@/assets/image/buddy/gradeTwoBuddy/buddy_leg.svg'),
    'snout': require('@/assets/image/buddy/gradeTwoBuddy/buddy_snout.svg'),
    'head_fuzz': require('@/assets/image/buddy/gradeTwoBuddy/buddy_hairs.svg'),
    'head_wrinkles': require('@/assets/image/buddy/gradeTwoBuddy/buddy_head-wrinkles.svg'),
    'body_wrinkles': require('@/assets/image/buddy/gradeTwoBuddy/buddy_body-wrinkles.svg'),
    'eyes-01': require('@/assets/image/buddy/gradeTwoBuddy/buddy_eyes-01.svg'),
    'eyes-02': require('@/assets/image/buddy/gradeTwoBuddy/buddy_eyes-02.svg'),
    'eyes-03': require('@/assets/image/buddy/gradeTwoBuddy/buddy_eyes-03.svg'),
    'eyes-04': require('@/assets/image/buddy/gradeTwoBuddy/buddy_eyes-04.svg'),
    'eyes-05': require('@/assets/image/buddy/gradeTwoBuddy/buddy_eyes-05.svg'),
    'eyes-06': require('@/assets/image/buddy/gradeTwoBuddy/buddy_eyes-06.svg'),
    'mouth-01': require('@/assets/image/buddy/gradeTwoBuddy/buddy_mouth-01.svg'),
    'mouth-02': require('@/assets/image/buddy/gradeTwoBuddy/buddy_mouth-02.svg'),
    'mouth-03': require('@/assets/image/buddy/gradeTwoBuddy/buddy_mouth-03.svg'),
    'mouth-04': require('@/assets/image/buddy/gradeTwoBuddy/buddy_mouth-04.svg'),
    'mouth-05': require('@/assets/image/buddy/gradeTwoBuddy/buddy_mouth-05.svg'),
    'mouth-06': require('@/assets/image/buddy/gradeTwoBuddy/buddy_mouth-06.svg'),
    'nose-01': require('@/assets/image/buddy/gradeTwoBuddy/buddy_nose-01.svg'),
    'nose-02': require('@/assets/image/buddy/gradeTwoBuddy/buddy_nose-02.svg'),
    'nose-03': require('@/assets/image/buddy/gradeTwoBuddy/buddy_nose-03.svg'),
    'nose-04': require('@/assets/image/buddy/gradeTwoBuddy/buddy_nose-04.svg'),
    'nose-05': require('@/assets/image/buddy/gradeTwoBuddy/buddy_nose-05.svg'),
    'nose-06': require('@/assets/image/buddy/gradeTwoBuddy/buddy_nose-06.svg'),
    'ears-01': require('@/assets/image/buddy/gradeTwoBuddy/buddy_ears-01.svg'),
    'ears-02': require('@/assets/image/buddy/gradeTwoBuddy/buddy_ears-02.svg'),
    'ears-03': require('@/assets/image/buddy/gradeTwoBuddy/buddy_ears-03.svg'),
    'ears-04': require('@/assets/image/buddy/gradeTwoBuddy/buddy_ears-04.svg'),
    'ears-05': require('@/assets/image/buddy/gradeTwoBuddy/buddy_ears-05.svg'),
    'ears-06': require('@/assets/image/buddy/gradeTwoBuddy/buddy_ears-06.svg'),
    'antenna-01': require('@/assets/image/buddy/gradeTwoBuddy/buddy_antenna-01.svg'),
    'antenna-02': require('@/assets/image/buddy/gradeTwoBuddy/buddy_antenna-02.svg'),
    'antenna-03': require('@/assets/image/buddy/gradeTwoBuddy/buddy_antenna-03.svg'),
    'antenna-04': require('@/assets/image/buddy/gradeTwoBuddy/buddy_antenna-04.svg'),
    'antenna-05': require('@/assets/image/buddy/gradeTwoBuddy/buddy_antenna-05.svg'),
    'antenna-06': require('@/assets/image/buddy/gradeTwoBuddy/buddy_antenna-06.svg'),
    'whiskers-01': require('@/assets/image/buddy/gradeTwoBuddy/buddy_whiskers-01.svg'),
    'whiskers-02': require('@/assets/image/buddy/gradeTwoBuddy/buddy_whiskers-02.svg'),
    'whiskers-03': require('@/assets/image/buddy/gradeTwoBuddy/buddy_whiskers-03.svg'),
    'whiskers-04': require('@/assets/image/buddy/gradeTwoBuddy/buddy_whiskers-04.svg'),
    'whiskers-05': require('@/assets/image/buddy/gradeTwoBuddy/buddy_whiskers-05.svg'),
    'whiskers-06': require('@/assets/image/buddy/gradeTwoBuddy/buddy_whiskers-06.svg'),


    //grade three
    'grade-three-body': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_body.svg'),
    'grade-three-arm': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_arm-01.svg'),
    //'grade-three-eyebrow': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_eyebrow.svg'),
    'grade-three-head': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_head-01.svg'),
    'grade-three-leg': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_leg_01.svg'),
    'grade-three-snout': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_snout.svg'),
    'grade-three-head_fuzz': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_hairs.svg'),
    'grade-three-head_wrinkles': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_wrinkles-head.svg'),
    'grade-three-body_wrinkles': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_wrinkles-body.svg'),
    'grade-three-eyes-01': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_eyes-01.svg'),
    'grade-three-eyes-02': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_eyes-02.svg'),
    'grade-three-eyes-03': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_eyes-03.svg'),
    'grade-three-eyes-04': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_eyes-04.svg'),
    'grade-three-eyes-05': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_eyes-05.svg'),
    'grade-three-eyes-06': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_eyes-06.svg'),
    'grade-three-mouth-01': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_mouth-01.svg'),
    'grade-three-mouth-02': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_mouth-02.svg'),
    'grade-three-mouth-03': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_mouth-03.svg'),
    'grade-three-mouth-04': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_mouth-04.svg'),
    'grade-three-mouth-05': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_mouth-05.svg'),
    'grade-three-mouth-06': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_mouth-06.svg'),
    'grade-three-nose-01': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_nose-01.svg'),
    'grade-three-nose-02': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_nose-02.svg'),
    'grade-three-nose-03': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_nose-03.svg'),
    'grade-three-nose-04': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_nose-04.svg'),
    'grade-three-nose-05': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_nose-05.svg'),
    'grade-three-nose-06': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_nose-06.svg'),
    'grade-three-ears-01': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_ears-01.svg'),
    'grade-three-ears-02': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_ears-02.svg'),
    'grade-three-ears-03': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_ears-03.svg'),
    'grade-three-ears-04': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_ears-04.svg'),
    'grade-three-ears-05': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_ears-05.svg'),
    'grade-three-ears-06': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_ears-06.svg'),
    'grade-three-antenna-01': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_antenna-01.svg'),
    'grade-three-antenna-02': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_antenna-02.svg'),
    'grade-three-antenna-03': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_antenna-03.svg'),
    'grade-three-antenna-04': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_antenna-04.svg'),
    'grade-three-antenna-05': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_antenna-05.svg'),
    'grade-three-antenna-06': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_antenna-06.svg'),
    /*
    'grade-three-whiskers-01': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_whiskers-01.svg'),
    'grade-three-whiskers-02': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_whiskers-02.svg'),
    'grade-three-whiskers-03': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_whiskers-03.svg'),
    'grade-three-whiskers-04': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_whiskers-04.svg'),
    'grade-three-whiskers-05': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_whiskers-05.svg'),
    'grade-three-whiskers-06': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_whiskers-06.svg'),
       */
    'tail': require('@/assets/image/buddy/gradeThreeBuddy/bb_g3_tail.svg'),
    'empty': require('@/assets/image/buddy/gradeOneBuddy/head-wrinkles.svg')
};

const bodyPartDatas = [
    {
        id: 'body',
        name: 'Middel',
        bodyType: BPID.MIDDLE,
        category: BPID.MIDDLE,
        customisable: false,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-body'],
            'grade-two': bodyPartRepository['body'],
            'grade-three': bodyPartRepository['grade-three-body'],
        },
    },
    {
        id: 'arm',
        name: 'Arm',
        bodyType: BPID.ARM_LEFT,
        category: BPID.ARM_LEFT,
        customisable: false,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-arm'],
            'grade-two': bodyPartRepository['arm'],
            'grade-three': bodyPartRepository['grade-three-arm'],
        },
    },
    {
        id: 'eyebrow',
        name: 'Wenkbrauw',
        bodyType: BPID.EYEBROW_LEFT,
        category: BPID.EYEBROW_LEFT,
        customisable: false,
        svgs: {
            'grade-one': bodyPartRepository['empty'],
            'grade-two': bodyPartRepository['eyebrow'],
            'grade-three': bodyPartRepository['empty'],
        },
    },
    {
        id: 'head',
        name: 'Hoofd',
        bodyType: BPID.HEAD,
        category: BPID.HEAD,
        customisable: false,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-head'],
            'grade-two': bodyPartRepository['head'],
            'grade-three': bodyPartRepository['grade-three-head'],
        },
    },
    {
        id: 'head_fuzz',
        name: 'Hoofd fuzz',
        bodyType: BPID.HEAD_FUZZ,
        category: BPID.HEAD_FUZZ,
        customisable: false,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-head_fuzz'],
            'grade-two': bodyPartRepository['head_fuzz'],
            'grade-three': bodyPartRepository['grade-three-head_fuzz'],
        },
    },
    {
        id: 'head_wrinkles',
        name: 'Hoofd wrinkles',
        bodyType: BPID.HEAD_WRINKLES,
        category: BPID.HEAD_WRINKLES,
        customisable: false,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-head_wrinkles'],
            'grade-two': bodyPartRepository['head_wrinkles'],
            'grade-three': bodyPartRepository['grade-three-head_wrinkles'],
        },
    },
    {
        id: 'body_wrinkles',
        name: 'Body wrinkles',
        bodyType: BPID.BODY_WRINKLES,
        category: BPID.BODY_WRINKLES,
        customisable: false,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-body_wrinkles'],
            'grade-two': bodyPartRepository['body_wrinkles'],
            'grade-three': bodyPartRepository['grade-three-body_wrinkles'],
        },
    },
    {
        id: 'leg',
        name: 'Been',
        bodyType: BPID.LEG_LEFT,
        category: BPID.LEG_LEFT,
        customisable: false,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-leg'],
            'grade-two': bodyPartRepository['leg'],
            'grade-three': bodyPartRepository['grade-three-leg'],
        },
    },
    {
        id: 'snout',
        name: 'Snuit',
        bodyType: BPID.SNOUT,
        category: BPID.SNOUT,
        customisable: false,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-snout'],
            'grade-two': bodyPartRepository['snout'],
            'grade-three': bodyPartRepository['grade-three-snout'],
        },
    },
    {
        id: 'eyes-01',
        name: 'Jolly',
        bodyType: BPID.EYES,
        category: BPID.EYES,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-eyes-01'],
            'grade-two': bodyPartRepository['eyes-01'],
            'grade-three': bodyPartRepository['grade-three-eyes-01'],
        },
    },
    {
        id: 'eyes-02',
        name: 'Katachtig',
        bodyType: BPID.EYES,
        category: BPID.EYES,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-eyes-02'],
            'grade-two': bodyPartRepository['eyes-02'],
            'grade-three': bodyPartRepository['grade-three-eyes-02'],
        },
    },
    {
        id: 'eyes-03',
        name: 'Triple',
        bodyType: BPID.EYES,
        category: BPID.EYES,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-eyes-03'],
            'grade-two': bodyPartRepository['eyes-03'],
            'grade-three': bodyPartRepository['grade-three-eyes-03'],
        },
    },
    {
        id: 'eyes-04',
        name: 'Amandel',
        bodyType: BPID.EYES,
        category: BPID.EYES,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-eyes-04'],
            'grade-two': bodyPartRepository['eyes-04'],
            'grade-three': bodyPartRepository['grade-three-eyes-04'],
        },
    },
    {
        id: 'eyes-05',
        name: 'Doorlopend',
        bodyType: BPID.EYES,
        category: BPID.EYES,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-eyes-05'],
            'grade-two': bodyPartRepository['eyes-05'],
            'grade-three': bodyPartRepository['grade-three-eyes-05'],
        },
    },
    {
        id: 'eyes-06',
        name: 'Kikker',
        bodyType: BPID.EYES,
        category: BPID.EYES,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-eyes-06'],
            'grade-two': bodyPartRepository['eyes-06'],
            'grade-three': bodyPartRepository['grade-three-eyes-06'],
        },
    }
    //MOND
    ,
    {
        id: 'mouth-01',
        name: 'Mond',
        bodyType: BPID.MOUTH,
        category: BPID.MOUTH,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-mouth-01'],
            'grade-two': bodyPartRepository['mouth-01'],
            'grade-three': bodyPartRepository['grade-three-mouth-01'],
        },
    },
    {
        id: 'mouth-02',
        name: 'Mond',
        bodyType: BPID.MOUTH,
        category: BPID.MOUTH,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-mouth-02'],
            'grade-two': bodyPartRepository['mouth-02'],
            'grade-three': bodyPartRepository['grade-three-mouth-02'],
        },
    },
    {
        id: 'mouth-03',
        name: 'Mond',
        bodyType: BPID.MOUTH,
        category: BPID.MOUTH,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-mouth-03'],
            'grade-two': bodyPartRepository['mouth-03'],
            'grade-three': bodyPartRepository['grade-three-mouth-03'],
        },
    },
    {
        id: 'mouth-04',
        name: 'Mond',
        bodyType: BPID.MOUTH,
        category: BPID.MOUTH,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-mouth-04'],
            'grade-two': bodyPartRepository['mouth-04'],
            'grade-three': bodyPartRepository['grade-three-mouth-04'],
        },
    },
    {
        id: 'mouth-05',
        name: 'Mond',
        bodyType: BPID.MOUTH,
        category: BPID.MOUTH,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-mouth-05'],
            'grade-two': bodyPartRepository['mouth-05'],
            'grade-three': bodyPartRepository['grade-three-mouth-05'],
        },
    },
    {
        id: 'mouth-06',
        name: 'Mond',
        bodyType: BPID.MOUTH,
        category: BPID.MOUTH,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-mouth-06'],
            'grade-two': bodyPartRepository['mouth-06'],
            'grade-three': bodyPartRepository['grade-three-mouth-06'],
        },
    }

    //NOSE

    ,
    {
        id: 'nose-01',
        name: 'Neus',
        bodyType: BPID.NOSE,
        category: BPID.NOSE,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-nose-01'],
            'grade-two': bodyPartRepository['nose-01'],
            'grade-three': bodyPartRepository['grade-three-nose-01'],
        },
    },
    {
        id: 'nose-02',
        name: 'Neus',
        bodyType: BPID.NOSE,
        category: BPID.NOSE,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-nose-02'],
            'grade-two': bodyPartRepository['nose-02'],
            'grade-three': bodyPartRepository['grade-three-nose-02'],
        },
    },
    {
        id: 'nose-03',
        name: 'Neus',
        bodyType: BPID.NOSE,
        category: BPID.NOSE,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-nose-03'],
            'grade-two': bodyPartRepository['nose-03'],
            'grade-three': bodyPartRepository['grade-three-nose-03'],
        },
    },
    {
        id: 'nose-04',
        name: 'Neus',
        bodyType: BPID.NOSE,
        category: BPID.NOSE,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-nose-04'],
            'grade-two': bodyPartRepository['nose-04'],
            'grade-three': bodyPartRepository['grade-three-nose-04'],
        },
    },
    {
        id: 'nose-05',
        name: 'Neus',
        bodyType: BPID.NOSE,
        category: BPID.NOSE,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-nose-05'],
            'grade-two': bodyPartRepository['nose-05'],
            'grade-three': bodyPartRepository['grade-three-nose-05'],
        },
    },
    {
        id: 'nose-06',
        name: 'Neus',
        bodyType: BPID.NOSE,
        category: BPID.NOSE,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-nose-06'],
            'grade-two': bodyPartRepository['nose-06'],
            'grade-three': bodyPartRepository['grade-three-nose-06'],
        },
    }

    // EARS

    ,
    {
        id: 'ears-01',
        name: 'Oren',
        bodyType: BPID.EAR_LEFT,
        category: BPID.EAR_LEFT,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-ears-01'],
            'grade-two': bodyPartRepository['ears-01'],
            'grade-three': bodyPartRepository['grade-three-ears-01'],
        },
    },
    {
        id: 'ears-02',
        name: 'Oren',
        bodyType: BPID.EAR_LEFT,
        category: BPID.EAR_LEFT,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-ears-02'],
            'grade-two': bodyPartRepository['ears-02'],
            'grade-three': bodyPartRepository['grade-three-ears-02'],
        },
    },
    {
        id: 'ears-03',
        name: 'Oren',
        bodyType: BPID.EAR_LEFT,
        category: BPID.EAR_LEFT,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-ears-03'],
            'grade-two': bodyPartRepository['ears-03'],
            'grade-three': bodyPartRepository['grade-three-ears-03'],
        },
    },
    {
        id: 'ears-04',
        name: 'Oren',
        bodyType: BPID.EAR_LEFT,
        category: BPID.EAR_LEFT,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-ears-04'],
            'grade-two': bodyPartRepository['ears-04'],
            'grade-three': bodyPartRepository['grade-three-ears-04'],
        },
    },
    {
        id: 'ears-05',
        name: 'Oren',
        bodyType: BPID.EAR_LEFT,
        category: BPID.EAR_LEFT,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-ears-05'],
            'grade-two': bodyPartRepository['ears-05'],
            'grade-three': bodyPartRepository['grade-three-ears-05'],
        },
    },
    {
        id: 'ears-06',
        name: 'Oren',
        bodyType: BPID.EAR_LEFT,
        category: BPID.EAR_LEFT,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-ears-06'],
            'grade-two': bodyPartRepository['ears-06'],
            'grade-three': bodyPartRepository['grade-three-ears-06'],
        },
    }

    //ANTENNAE
    ,
    {
        id: 'antenna-01',
        name: 'Antenne',
        bodyType: BPID.ANTENNA,
        category: BPID.ANTENNA,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-antenna-01'],
            'grade-two': bodyPartRepository['antenna-01'],
            'grade-three': bodyPartRepository['grade-three-antenna-01'],
        },
    },
    {
        id: 'antenna-02',
        name: 'Antenne',
        bodyType: BPID.ANTENNA,
        category: BPID.ANTENNA,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-antenna-02'],
            'grade-two': bodyPartRepository['antenna-02'],
            'grade-three': bodyPartRepository['grade-three-antenna-02'],
        },
    },
    {
        id: 'antenna-03',
        name: 'Antenne',
        bodyType: BPID.ANTENNA,
        category: BPID.ANTENNA,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-antenna-03'],
            'grade-two': bodyPartRepository['antenna-03'],
            'grade-three': bodyPartRepository['grade-three-antenna-03'],
        },
    },
    {
        id: 'antenna-04',
        name: 'Antenne',
        bodyType: BPID.ANTENNA,
        category: BPID.ANTENNA,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-antenna-04'],
            'grade-two': bodyPartRepository['antenna-04'],
            'grade-three': bodyPartRepository['grade-three-antenna-04'],
        },
    },
    {
        id: 'antenna-05',
        name: 'Antenne',
        bodyType: BPID.ANTENNA,
        category: BPID.ANTENNA,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-antenna-05'],
            'grade-two': bodyPartRepository['antenna-05'],
            'grade-three': bodyPartRepository['grade-three-antenna-05'],
        },
    },
    {
        id: 'antenna-06',
        name: 'Antenne',
        bodyType: BPID.ANTENNA,
        category: BPID.ANTENNA,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['grade-one-antenna-06'],
            'grade-two': bodyPartRepository['antenna-06'],
            'grade-three': bodyPartRepository['grade-three-antenna-06'],
        },
    },


    //  WHISKERS

    {
        id: 'whiskers-01',
        name: 'Whisker',
        bodyType: BPID.WHISKERS,
        category: BPID.WHISKERS,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['empty'],
            'grade-two': bodyPartRepository['whiskers-01'],
            'grade-three': bodyPartRepository['empty'],
        },
    },
    {
        id: 'whiskers-02',
        name: 'Whisker',
        bodyType: BPID.WHISKERS,
        category: BPID.WHISKERS,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['empty'],
            'grade-two': bodyPartRepository['whiskers-02'],
            'grade-three': bodyPartRepository['empty'],
        },
    },
    {
        id: 'whiskers-03',
        name: 'Whisker',
        bodyType: BPID.WHISKERS,
        category: BPID.WHISKERS,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['empty'],
            'grade-two': bodyPartRepository['whiskers-03'],
            'grade-three': bodyPartRepository['empty'],
        },
    },
    {
        id: 'whiskers-04',
        name: 'Whisker',
        bodyType: BPID.WHISKERS,
        category: BPID.WHISKERS,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['empty'],
            'grade-two': bodyPartRepository['whiskers-04'],
            'grade-three': bodyPartRepository['empty'],
        },
    },
    {
        id: 'whiskers-05',
        name: 'Whisker',
        bodyType: BPID.WHISKERS,
        category: BPID.WHISKERS,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['empty'],
            'grade-two': bodyPartRepository['whiskers-05'],
            'grade-three': bodyPartRepository['empty'],
        },
    },
    {
        id: 'whiskers-06',
        name: 'Whisker',
        bodyType: BPID.WHISKERS,
        category: BPID.WHISKERS,
        customisable: true,
        svgs: {
            'grade-one': bodyPartRepository['empty'],
            'grade-two': bodyPartRepository['whiskers-06'],
            'grade-three': bodyPartRepository['empty'],
        },
    },
    {
        id: 'tail',
        name: 'Tail',
        bodyType: BPID.TAIL,
        category: BPID.TAIL,
        customisable: false,
        svgs: {
            'grade-one': bodyPartRepository['empty'],
            'grade-two': bodyPartRepository['empty'],
            'grade-three': bodyPartRepository['tail'],
        },
    }
];


const parser = new DOMParser();

export default class BodyPartLibrary
{

    static getAllBodyPartDatas()
    {
        return bodyPartDatas;
    }

    static getBodyPartFromFile(id, grade)
    {
        return new Promise((resolve) =>
        {
            let bodyPartLocation = this.getBodyPartLocationForGrade(grade, id);
            fetch(bodyPartLocation)
                .then(r => r.text())
                .then(text =>
                {
                    let doc = parser.parseFromString(text, "image/svg+xml");
                    let svgEL = doc.getElementsByTagNameNS("http://www.w3.org/2000/svg", "svg").item(0);
                    let resultObject = {
                        id: id,
                        svg: svgEL
                    }
                    resolve(resultObject);
                })
                .catch(console.error.bind(console));
        });
    }

    static getBodyPartLocationForGrade(schoolYear, id)
    {
        //logger.info("getting body part location for id " + id + " and grade " + grade)
        let data = this.findDataForId(id);
        let location = null;

        let grade = utils.getGradeForSchoolYear(schoolYear);
        
        switch (grade)
        {
            case 1:
                location = data.svgs['grade-one'];
                break;
            case 2:
                location = data.svgs['grade-two'];
                break;
            case 3:
                location = data.svgs['grade-three'];
                break;
        }
        return location;
    }

    static getAllCustomisableBodyParts(grade)
    {
        return new Promise(function(resolve, reject)
        {
                let promises = [];

                bodyPartDatas.forEach(data =>
                {

                    let promise = BodyPartLibrary.getBodyPartFromFile(data.id, grade);
                    promises.push(promise);
                });

                Promise.all(promises).then((values) =>
                    {
                        let combined = BodyPartLibrary.combineDataAndSvg(values, true);
                        resolve(combined);
                    })
                    .catch(function(error)
                    {
                        console.log(error);
                        reject(error);
                    });
        });
    }

    static combineDataAndSvg(svgs, onlyCustomisables)
    {
        let dataAndSvgs = {};
        svgs.forEach(svgPart =>
        {
            let data = BodyPartLibrary.findDataForId(svgPart.id);
            if ((onlyCustomisables && data.customisable === true) || !onlyCustomisables)
            {
                let combined = {
                    id: data.id,
                    name: data.name,
                    bodyType: data.bodyType,
                    category: data.category,
                    svg: svgPart.svg,
                }

                if (!(data.bodyType in dataAndSvgs))
                {
                    dataAndSvgs[data.bodyType] = {
                        id: data.bodyType,
                        name: BodyPartNames[data.bodyType],
                        parts: []
                    };
                }

                dataAndSvgs[data.bodyType].parts.push(combined);
            }


        });

        return dataAndSvgs;
    }

    static findDataForId(id)
    {
        let result = null;
        bodyPartDatas.forEach(data =>
        {
            if (data.id === id)
            {
                result = data;
            }
        });
        return result;
    }

}

